import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const createReducer = ({
    FEATURES = {}
}) => {
    const initState = {
        ...FEATURES
    }

    return handleActions({
        [ActionTypes.SET_FEATURES]: (state, {payload: features}) => ({
            ...features
        }),
        [ActionTypes.UPDATE_FEATURES]: (state, {payload: part}) => ({
            ...state,
            ...part
        }),
    }, initState)
}

export default createReducer



// WEBPACK FOOTER //
// ./web/js/features/reducer.js